module.exports = __webpack_public_path__ + "bc.no1.2c0e7ee0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bc.no1.jpg
// module id = TvNO
// module chunks = 0